import { graphql } from "react-relay";

export const AddPolicyCollectionMutation = graphql`
  mutation AddPolicyCollectionMutation(
    $input: AddPolicyCollectionInput!
    $connections: [ID!]!
  ) {
    addPolicyCollection(input: $input) {
      collection
        @appendNode(
          connections: $connections
          edgeTypeName: "PolicyCollectionEdge"
        ) {
        autoUpdate
        description
        id
        name
        policyMappings {
          edges {
            node {
              policy {
                name
                uuid
                version
              }
            }
          }
        }
        provider
        roleAssignmentTarget
        uuid
      }
    }
  }
`;
